import { createClient } from "@sanity/client";

const sanityClient = createClient({
    projectId: "krjmu28b",
    dataset: "production"
});

export default sanityClient;